import { ITrainersData } from '@/types/trainers';
import Benchmark from './Benchmark';
import Metadata from './Metadata';

interface Props {
  elementRef: React.RefObject<HTMLDivElement>;
  data?: ITrainersData;
  isBenchmark?: boolean;
  onBenchmarkToggle?: (checked: boolean) => void;
  lat?: number;
  lon?: number;
}

export default function TrainerFooter({
  data,
  elementRef,
  onBenchmarkToggle = () => {},
  isBenchmark = false,
  lat,
  lon,
}: Props) {
  const { metadata } = data?.content || {};
  return (
    <div
      className="relative flex w-full flex-row items-center justify-center bg-neutral-1000 px-2 py-1"
      ref={elementRef}>
      <div className="absolute left-4 top-1">
        <Metadata
          data={data?.content}
          lat={lat || metadata?.position?.lat}
          lon={lon || metadata?.position?.lon}
        />
      </div>
      <Benchmark checked={isBenchmark} onChange={onBenchmarkToggle} />
    </div>
  );
}
